import React from 'react'
import ChangelogFilterItem from './ChangelogFilterItem'
import styles from './styles.module.css'

const ChangelogFilterList = ({ filterGroupName, filter, onSelect }) => {
  return (
    <div className={styles.checklistItems}>
      {filter[filterGroupName].map(({ title, value, selected }, index) => (
        <ChangelogFilterItem
          key={`filter-item-${index}`}
          value={value}
          isChecked={selected}
          onSelect={onSelect}
          filterGroupName={filterGroupName}
          data-testid={`${filterGroupName}-checkbox-${index}`}
        >
          {title}
        </ChangelogFilterItem>
      ))}
    </div>
  )
}

export default ChangelogFilterList
